<template>
  <a-modal
      :title="title"
      :visible="visible"
      :width="1300"
      @cancel="handleCancel"
      :maskClosable="false">
    <template slot="footer">
      <a-button key="back" @click="handleCancel">
        取消
      </a-button>
      <a-button key="submit" style="margin-left: 15px;" type="primary" @click="handleSubmit" :loading="submitLoading">
        继续完善
      </a-button>
    </template>
    <a-form-model
        ref="targetForm"
        :model="form"
        :rules="rules"
        :label-col="{span: 5}"
        :wrapper-col="{span: 18}">
      <a-layout>
        <a-layout-content>
          <a-row class="form-row">
            <a-col :span="12">
              <a-form-model-item label="身份证号" prop="idcard">
                <a-input v-model="form.idcard" placeholder="例如 22010***********"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="姓名" prop="chineseName">
                <a-input v-model="form.chineseName" placeholder="例如 李心安"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row class="form-row">
            <a-col :span="12">
              <a-form-model-item label="姓(拼音)" prop="firstName">
                <a-input v-model="form.lastName" placeholder="例如 li"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="名(拼音)" prop="lastName">
                <a-input v-model="form.firstName" placeholder="例如 xinan"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row class="form-row">
            <a-col :span="12">
              <a-form-model-item label="民族" prop="nation">
                <a-input v-model="form.nation" placeholder="例如 汉"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="性别" prop="sex">
                <a-radio-group v-model="form.sex">
                  <a-radio value="Male">男</a-radio>
                  <a-radio value="Female">女</a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row class="form-row">
            <a-col :span="12">
              <a-form-model-item label="出生日期" prop="birth">
                <a-date-picker style="width: 100%" v-model.trim="form.birth" :disabled-date="afterNow"
                               value-format="YYYY-MM-DD"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="出生地址" prop="birthPlace">
                <a-input v-model="form.birthPlace" placeholder="例如 广东"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row class="form-row">
            <a-col :span="12">
              <a-form-model-item label="住址" prop="address">
                <a-input v-model="form.address" placeholder="长春市二道区四家乡*****"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row class="form-row">
            <a-col :span="12">
              <a-form-model-item label="护照号" prop="passport">
                <a-input v-model="form.passport" placeholder="例如 EJ60*****"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="护照签发地" prop="issuePlace">
                <a-input v-model="form.issuePlace" placeholder="例如 广东"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row class="form-row">
            <a-col :span="12">
              <a-form-model-item label="护照签发日" prop="issueDate">
                <a-date-picker style="width: 100%" v-model.trim="form.issueDate" :disabled-date="afterNow"
                               value-format="YYYY-MM-DD"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="护照有效期" prop="expiryDate">
                <a-date-picker style="width: 100%" v-model.trim="form.expiryDate" :disabled-date="beforeNow"
                               value-format="YYYY-MM-DD"/>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-layout-content>
        <a-layout-sider :width="300">
          <a-row class="form-row">
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
              <a-upload
                  name="file"
                  v-model="form.idcardImgUrl"
                  list-type="picture-card"
                  class="avatar-uploader"
                  :show-upload-list="false"
                  :action="url.recognition"
                  :data="{platform: 'myself', template: 'idcard'}"
                  :headers="this.headersWithoutJson"
                  :before-upload="beforeUpload"
                  @change="handleIdcardChange">
                <img v-if="form.idcardImgUrl" :src="form.idcardImgUrl" width="282.22px"/>
                <div v-else>
                  <a-icon :type="idcardImg.loading ? 'loading' : 'plus'"/>
                  <div class="ant-upload-text">
                    身份证
                  </div>
                </div>
              </a-upload>
            </a-col>
          </a-row>
          <a-row class="form-row">
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
              <a-upload
                  name="file"
                  v-model="form.passportImgUrl"
                  list-type="picture-card"
                  class="avatar-uploader"
                  :show-upload-list="false"
                  :action="url.recognition"
                  :data="{platform: 'baidu', template: 'passport'}"
                  :headers="this.headersWithoutJson"
                  :before-upload="beforeUpload"
                  @change="handlePassportChange">
                <img v-if="form.passportImgUrl" :src="form.passportImgUrl" width="282.22px"/>
                <div v-else>
                  <a-icon :type="passportImg.loading ? 'loading' : 'plus'"/>
                  <div class="ant-upload-text">
                    护照
                  </div>
                </div>
              </a-upload>
            </a-col>
          </a-row>
        </a-layout-sider>
      </a-layout>
    </a-form-model>
    <DetailCreateModal ref="detailCreateModal"></DetailCreateModal>
  </a-modal>
</template>

<script>
import DetailCreateModal from "@/components/krDs/DetailCreateModal";
import moment from "moment";
import {HttpMixins} from "@/mixins/http-mixins";

const pattern = {
  englishName: /^[A-Za-z]+$/,
  chinese: /^([\u4E00-\u9FA5]+)$/,
  passport: /^([A-Z]|[0-9]){5,17}$/,
  idcard: /^(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)|(^([A-Z]|[0-9]){5,17}$)$/,
  mail: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
}

export default {
  name: "CreateModal",
  components: {DetailCreateModal},
  mixins: [HttpMixins],
  data() {
    return {
      moment,
      title: '',
      visible: false,
      submitLoading: false,
      form: {},
      idcardImg: {
        loading: false,
      },
      passportImg: {
        loading: false,
      },
      rules: {
        passport: [{required: true, pattern: pattern.passport, message: '输入有误,A-Z或0-9'}],
        idcard: [{pattern: pattern.idcard, message: '输入有误,A-Z或0-9'}],
        chineseName: [{pattern: pattern.chinese, message: '输入有误,中文'}],
        firstName: [{required: true, pattern: pattern.englishName, message: '输入有误,a-z'}],
        lastName: [{required: true, pattern: pattern.englishName, message: '输入有误,a-z'}],
        sex: [{required: true, message: '请选择'}],
        issuePlace: [{required: true, message: '必填!'}],
        birthPlace: [{required: true, message: '必填!'}],
        birth: [{required: true, message: '必填!'}],
        issueDate: [{required: true, message: '必填!'}],
        expiryDate: [{required: true, message: '必填!'}],
        address: [{required: true, message: '请输入地址'}],
        nation: [{}],
        idcardImgUrl: [{required: true, message: '请上传图片文件'}],
        passportImgUrl: [{required: true, message: '请上传图片文件'}],
      },
      url: {
        add: window._CONFIG['domainURL'] + "/krDs",
        edit: window._CONFIG['domainURL'] + "/krDs",
        upload: window._CONFIG['domainURL'] + "/power/uploadFile",
        recognition: window._CONFIG['domainURL'] + "/power/recognition"
      }
    }
  },
  methods: {
    show(record) {
      this.visible = true;
      this.submitLoading = false;
      this.$nextTick(() => {
        this.$refs.targetForm.resetFields();
        if (record) {
          this.title = '编辑';
          this.form = Object.assign({}, record);
        } else {
          this.title = '新增';
          this.form = {};
        }
      })
    },
    handleSubmit() {
      const that = this;
      this.$refs.targetForm.validate(valid => {
        if (valid) {
          if (!that.form.idcardImgUrl) {
            that.$message.warning("请上传身份证");
            return
          }
          if (!that.form.passportImgUrl) {
            that.$message.warning("请上传护照");
            return
          }
          that.submitLoading = true;
          if (that.title === '编辑') {
            that.$axios.put(that.url.edit, that.form, {headers: that.headers})
                .then((res) => {
                  let response = res.data;
                  if (response.code === 200) {
                    that.handleCancel();
                    that.$refs.detailCreateModal.show(that.form, '继续完善', that);
                  } else {
                    that.$message.error(response.msg);
                  }
                })
                .catch((error) => {
                  that.catchError(error);
                })
                .finally(() => {
                  that.submitLoading = false;
                });
          }
          if (that.title === '新增') {
            that.$axios.post(that.url.add, that.form, {headers: that.headers})
                .then((res) => {
                  let response = res.data;
                  if (response.code === 200) {
                    that.$emit('ok');
                    that.handleCancel();
                    that.$refs.detailCreateModal.show({id: response.data.id}, '继续完善', that);
                  } else {
                    that.$message.error(response.msg);
                  }
                })
                .catch((error) => {
                  that.catchError(error);
                })
                .finally(() => {
                  that.submitLoading = false;
                });
          }
        }
      });
    },
    handleCancel() {
      this.visible = false;
    },
    afterNow(current) {
      return current && current > moment().startOf('day')
    },
    beforeNow(current) {
      return current && current < moment().startOf('day');
    },
    beforeUpload(file) {
      let that = this;
      const isJpg = file.type === 'image/jpeg';
      if (!isJpg) {
        that.$message.error('只支持上传 JPG 格式!');
        return false;
      }
      const isLt200kb = file.size / 1024 < 800;
      if (!isLt200kb) {
        that.$message.error('证件文件大小必须小于 800KB!');
        return false;
      }
      const isSize = new Promise(function (resolve, reject) {
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function () {
          let valid = img.width < 2400 && img.height < 2400;
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      }).then(() => {
        return file;
      }, () => {
        that.$message.error('上传图片分辨率要小于2400*2400px!');
        return Promise.reject();
      });
      return isSize;
    },
    handleIdcardChange(info) {
      if (info.file.status === 'uploading') {
        this.idcardImg.loading = true;
        this.$set(this.form, 'idcardImgUrl', '');
      }
      if (info.file.status === 'done') {
        this.idcardImg.loading = false;
        let response = info.file.response;
        if (response.code === 200) {
          this.$set(this.form, 'idcardImgUrl', response.data.url);
          this.$set(this.form, 'idcard', response.data.num);
          this.$set(this.form, 'chineseName', response.data.name);
          this.$set(this.form, 'nation', response.data.nation);
          this.$set(this.form, 'sex', response.data.sex === '男' ? 'Male' : 'Female');
          this.$set(this.form, 'birth', response.data.birth);
          this.$set(this.form, 'address', response.data.address);
        }
      }
      if (info.file.status === 'error') {
        this.idcardImg.loading = false;
      }
    },
    handlePassportChange(info) {
      if (info.file.status === 'uploading') {
        this.passportImg.loading = true;
        this.$set(this.form, 'passportImgUrl', '');
      }
      if (info.file.status === 'done') {
        this.passportImg.loading = false;
        let response = info.file.response;
        if (response.code === 200) {
          this.$set(this.form, 'passportImgUrl', response.data.url);
          this.$set(this.form, 'passport', response.data.passport);
          this.$set(this.form, 'firstName', response.data.firstName);
          this.$set(this.form, 'lastName', response.data.lastName);
          let issuePlace = response.data.issuePlace.split("/");
          this.$set(this.form, 'issuePlace', issuePlace[1]);
          let birthPlace = response.data.birthPlace.split("/");
          this.$set(this.form, 'birthPlace', birthPlace[1]);
          this.$set(this.form, 'issueDate', response.data.issueDate);
          this.$set(this.form, 'expiryDate', response.data.expiryDate);
        }
      }
      if (info.file.status === 'error') {
        this.passportImg.loading = false;
      }
    },
  }
}
</script>

<style scoped>
.ant-layout-content, .ant-layout-sider {
  background: #fff;
}

>>> .ant-upload.ant-upload-select-picture-card {
  width: 300px;
  height: 180px;
}

</style>
